'use strict';

angular.module('supervisorAccessReviewControllers')

.controller('SystemToReviewCtrl', ['$scope', '$state', 'authLogin', 'authUser', 'systemToReviewService', 'stateAccessReview', 'relatedInfos', function ($scope, $state, authLogin, authUser,systemToReviewService, stateAccessReview, relatedInfos) {

    $scope.accessReview = relatedInfos.accessReview;
    $scope.stateAccessReview = stateAccessReview;
    $scope.systemToReview = relatedInfos.systemToReview;
    $scope.systemID = relatedInfos.systemID;
    $scope.systemRoleID = relatedInfos.systemRoleID;

    // Redirections

    if (_.isEmpty($scope.accessReview)) {
        $state.go('accessReview.noAccessReview', null, { reload: true });
        return;
    }

    if ($scope.stateAccessReview.StateName === 'Submitted' && !$state.is('accessReview.authUser.submitted') && !authUser.IsInAdministrationGroup) {
        $state.go('accessReview.authUser.submitted', null, { reload: true });
        return;
    }

    if (_.isEmpty($scope.systemToReview) || _.isNull($scope.systemToReview)) {
        $state.go('accessReview.authUser.systemToReview.summary',
                  { authLogin: authLogin },
                  { reload: true });
        return;
    }

    // Properties

    $scope.systemToReview.groups = _.groupBy($scope.systemToReview.SystemRolesToReview,
                                            function (s) { return s.SystemRole.Name; });
    $scope.businessSystem = $scope.systemToReview.BusinessSystem;

    // Methods

    $scope.confirmSystemReview = function () {
        $scope.currentSystemRoleID = $scope.systemToReview.SystemRolesToReview[0].SystemRole.SystemRoleID;
        systemToReviewService.confirmSystemReview($scope.systemToReview, authLogin)
            .then(function () {
             
            $scope.$broadcast('newReviewSystem');

            systemToReviewService.getNextSystemRoleToReview(authLogin)
                                 .then(function (nextSystemRoleToReview) {
                                     var nextSystemRole = nextSystemRoleToReview.data;

                                     if (_.isEmpty(nextSystemRole)) {
                                        $state.go('accessReview.authUser.systemToReview.summary',
                                        { authLogin: authLogin },
                                        { reload: true });
                                        return;
                                     }
                             
                                     var systemRoleID = nextSystemRole.SystemRole.SystemRoleID;
                                     $state.go('accessReview.authUser.systemToReview.systemRole',
                                     {
                                        authLogin: authLogin,
                                         systemRoleID: systemRoleID
                                         });
                                 });
        });
    };

    $scope.needToConfirmSystemReview = function () {
        var withToRemoves = _.filter($scope.systemToReview.SystemRolesToReview,
                                     function (s) { return s.ToRemoveRight; });
        return withToRemoves.length > 0;
    };

    $scope.getSystemCssIcon = function (businessSystem) {
        var systemCssIcon = businessSystem.SystemCssIcon;

        if (_.isUndefined(systemCssIcon) || _.isEmpty(systemCssIcon)) {
            systemCssIcon = 'fa fa-laptop';
        }

        return systemCssIcon;
    };
}]);

